'use strict';

export const ACCEPT_REGIONS: string[] = ['AF', 'AL', 'DZ', 'AD', 'AO', 'AI', 'AG', 'AR', 'AM', 'AW', 'AU',
  'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BA', 'BW',
  'BR', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'TD', 'CL', 'CN', 'CO',
  'KM', 'CK', 'CR', 'HR', 'CY', 'CZ', 'CD', 'DK', 'DJ', 'DM', 'DO', 'TL', 'EC', 'EG', 'SV',
  'GQ', 'EE', 'ET', 'FO', 'FJ', 'FI', 'FR', 'GF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR',
  'GL', 'GD', 'GP', 'GU', 'GT', 'GN', 'GW', 'GY', 'HT', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID',
  'IQ', 'IE', 'IL', 'IT', 'CI', 'JM', 'JP', 'JO', 'KZ', 'KE', 'KI', 'KW', 'KG', 'LA', 'LV',
  'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'FY', 'RO', 'MK', 'MG', 'MW', 'MY', 'MV',
  'ML', 'MT', 'MQ', 'MR', 'MU', 'MX', 'MD', 'MC', 'MO', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA',
  'NP', 'NL', 'AN', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG',
  'PY', 'PE', 'PH', 'PL', 'PT', 'PR', 'QA', 'CG', 'RE', 'RO', 'RU', 'RW', 'KN', 'LC', 'VC',
  'WS', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SK', 'SI', 'SB', 'SO', 'ZA', 'KR', 'SS',
  'ES', 'LK', 'SR', 'SZ', 'SE', 'CH', 'TW', 'TJ', 'TZ', 'TH', 'TG', 'TO', 'TT', 'TN', 'TR',
  'TM', 'TC', 'UG', 'UA', 'AE', 'GB', 'US', 'UY', 'UZ', 'VU', 'VE', 'VN', 'VG', 'US', 'VI',
  'YE', 'ZM', 'ZW'];
